// extracted by mini-css-extract-plugin
export default {"tagItem":"JpeztPvp","plainTag":"Z_oI5BOm"};